import { addDays, DateArg, format, getDay, startOfWeek } from 'date-fns'
import { de } from 'date-fns/locale/de'

export function formatGerman(date: DateArg<Date>, formatString: string) {
  return format(date, formatString, { locale: de })
}

export function setWeekday(date: DateArg<Date>, index: number) {
  return addDays(startOfWeek(date, { weekStartsOn: 1 }), index)
}

export function getWeekday(date: DateArg<Date>) {
  return (((getDay(date) - 1) % 7) + 7) % 7
}
